/*
 * axios 封装
 * */

 import axios from 'axios'
 import store from '@/store/index'
 import router from '@/router/index'
 import { getToken, removeToken } from '@/utils/auth'
 import { Message } from 'element-ui'
 import qs from 'qs'


let baseURL = '/api'

if(location.hostname == 'localhost'){
  baseURL= 'http://localhost:54575/api';
  //baseURL = 'https://hy.minica.cn/api';
}

const exportServer = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 1000*60*60*24,                  // 请求超时时间
})

// request拦截器
exportServer.interceptors.request.use(
	config => {
		if( getToken()){
			config.headers['Authorization'] = getToken(); //为每个请求带上token
		}
		config.responseType = 'blob'
		return config;
	},

	error => {
		console.log(error) // for debug
  		Promise.reject(error)
	}
)


// respone拦截器
exportServer.interceptors.response.use(
	response => {
    // 错误时不下载文件
    console.log(response.data);
    if(response.data.type == 'application/json') {
      return response;
    }
    if(response.data.type == 'application/zip') {
      saveAs.saveAs(fileData.data, `资料.zip`)
      return response;
    }

		//返回数据
		let date = new Date();
    let filefix = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    let blob = new Blob([response.data]); //创建一个blob对象
    let a = document.createElement('a'); //创建一个<a></a>标签
    a.href = URL.createObjectURL(blob); // response is a blob
    a.download = filefix + "下载文件.xlsx";  //文件名称
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();

		return response;
	},
	error => {
		console.log('err' + error)// for debug
		if(error.response && error.response.status==401){
			removeToken();
			router.push({ path: "/"})
		}else{
		}

    Message({
      message: error.message,
      type: 'error',
      showClose: true,
      duration: 3 * 1000
    });
    return Promise.reject(error);

	}
)



export default exportServer
